import { BorderRadius, Color, getShadow, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

import { PopoverBannerPosition } from './types/popoverBannerPosition'
import { getArrowPositionVariants } from './utils/getArrowPositionVariants'
import { getBannerAnimation } from './utils/getBannerAnimation'
import { getBannerPositionVariants } from './utils/getBannerPositionVariants'

const ARROW_SIZE = '11px'

export const BannerWrapper = styled.div`
  position: relative;
`

interface BannerWrapperProps {
  isVisible: boolean
  position: PopoverBannerPosition
}

export const BannerContent = styled.div<BannerWrapperProps>`
  display: flex;
  opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
  align-items: center;
  gap: ${Spacing.S8};
  justify-content: space-between;
  padding: 0 0 0 ${Spacing.S12};
  border-radius: ${BorderRadius.R8};
  position: absolute;
  ${({ position }) => getBannerPositionVariants()[position]}
  z-index: 1;
  background-color: ${Color.Black};
  box-shadow: ${getShadow('raisedStrong')};
  pointer-events: ${({ isVisible }) => (isVisible ? 'all' : 'none')};
  animation: ${({ isVisible, position }) => (isVisible ? getBannerAnimation(position) : 'none')} 0.5s ease-out;

  transition: opacity 0.5s ease;
`

export const BannerArrow = styled.div<{ position: PopoverBannerPosition }>`
  width: ${ARROW_SIZE};
  height: ${ARROW_SIZE};
  position: absolute;
  z-index: 1;
  transform: rotate(45deg);
  background: ${Color.Black};
  ${({ position }) => getArrowPositionVariants[position]}
`
